import React from 'react';

/**
 * Hero illustration, drawn in HTML/CSS (no image file): a payment link checkout,
 * then "Payment received", then "Settled". Plays once on load; with reduced
 * motion it shows the final state straight away. Example data only.
 */
const METHODS = ['Bank transfer', 'Card', 'USSD', 'PayAttitude', 'Virtual account'];

function HeroVisual() {
    return (
        <div className="wqh-visual" aria-hidden="true">
            <div className="wqh-backdrop" />

            <div className="wqh-checkout">
                <div className="wqh-merchant">
                    <span className="wqh-avatar">AF</span>
                    <div>
                        <p className="wqh-merchant-name">Ade’s Fabrics</p>
                        <p className="wqh-merchant-sub">Payment link</p>
                    </div>
                </div>

                <p className="wqh-label">Amount</p>
                <p className="wqh-amount">₦25,000.00</p>

                <p className="wqh-label">Pay with</p>
                <ul className="wqh-methods">
                    {METHODS.map((m, i) => (
                        <li key={m} className={i === 0 ? 'is-selected' : undefined}>
                            {m}
                        </li>
                    ))}
                </ul>

                <div className="wqh-pay">Pay ₦25,000.00</div>
                <p className="wqh-secured">Secured by WayaQuick</p>
            </div>

            <div className="wqh-toast wqh-toast-received">
                <span className="wqh-tick" />
                <div>
                    <p className="wqh-toast-title">Payment received</p>
                    <p className="wqh-toast-sub">₦25,000.00 · Bank transfer</p>
                </div>
            </div>

            <div className="wqh-toast wqh-toast-settled">
                <p className="wqh-toast-sub">Settled to your bank</p>
                <p className="wqh-settled-amount">₦24,625.00</p>
                <p className="wqh-toast-sub">after the 1.5% fee</p>
            </div>
        </div>
    );
}

export default React.memo(HeroVisual);
